import { memo } from 'react';

import { Clock, CreditIcon } from '@air/next-icons';
import { Chip } from '@air/primitive-chip';

import { type AiModelConfig } from '../../../api/aimodels/useAiModels';
import { formatDuration } from './formatDuration';

type ModelTooltipContentProps = { model: AiModelConfig };

export const ModelTooltipContent = memo(({ model }: ModelTooltipContentProps) => (
  <div className="flex flex-col gap-2">
    <span className="font-semibold text-12 text-gray-12">{model.name}</span>
    <span className="text-12 text-gray-10">{model.description}</span>
    {(model.defaultCredits !== undefined || model.defaultDurationMs !== undefined) && (
      <div className="flex items-center gap-1">
        {model.defaultCredits !== undefined && (
          <Chip color="grey" shape="rectangular" size="small">
            <CreditIcon className="size-4 shrink-0" />
            {model.defaultCredits}
          </Chip>
        )}
        {model.defaultDurationMs !== undefined && (
          <Chip color="grey" shape="rectangular" size="small">
            <Clock className="size-3 shrink-0" />
            {formatDuration(model.defaultDurationMs)}
          </Chip>
        )}
      </div>
    )}
  </div>
));

ModelTooltipContent.displayName = 'ModelTooltipContent';
